import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';

export const Modal = ({ isOpen, onClose, title, children, size = 'max-w-2xl', fullWidth = true, panelClassName = 'bg-white rounded-lg p-6' }) => {
  // Renderizar en portal hacia un contenedor estable dentro del body.
  // Fijamos el contenedor una sola vez y lo creamos si no existe para
  // evitar que cambie entre renders y provoque errores de reconciliación.
  const container = useMemo(() => {
    if (typeof document === 'undefined') return null;
    let el = document.getElementById('modal-root');
    if (!el) {
      el = document.createElement('div');
      el.id = 'modal-root';
      document.body.appendChild(el);
    }
    return el || document.body;
  }, []);

  if (!isOpen || !container) return null;

  const modalContent = (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 md:p-8 z-50 overflow-y-auto"
      role="dialog"
      aria-modal="true"
    >
      <div className={`${panelClassName} ${fullWidth ? 'w-full max-w-[96vw]' : ''} ${size} max-h-[90vh] overflow-y-auto overflow-x-auto relative`}>
        {title ? (
          <div className="sticky top-0 bg-white pt-2 pb-3 mb-4 z-10 flex justify-between items-center border-b">
            <h3 className="text-lg font-bold">{title}</h3>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
              aria-label="Cerrar"
            >
              ✕
            </button>
          </div>
        ) : (
          <button
            onClick={onClose}
            className="absolute top-1 right-1 rounded-full w-8 h-8 flex items-center justify-center"
            style={{ backgroundColor: '#FFF', border: '2px solid #F07E2D', color: '#776F74' }}
            aria-label="Cerrar"
          >
            ✕
          </button>
        )}
        {children}
      </div>
    </div>
  );
  return ReactDOM.createPortal(modalContent, container);
};
